import { createAction } from '@reduxjs/toolkit';

export const FETCH_MESSAGESESSION_ACTION_TYPE = 'saga/fetchMessageSession';
export const fetchMessageSessionAction = createAction(FETCH_MESSAGESESSION_ACTION_TYPE);
